import { render, staticRenderFns } from "./StatsPanel.vue?vue&type=template&id=00427c54"
import script from "./StatsPanel.vue?vue&type=script&lang=js"
export * from "./StatsPanel.vue?vue&type=script&lang=js"
import style0 from "./StatsPanel.vue?vue&type=style&index=0&id=00427c54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports